// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._37af77{background:var(--subtle);border-radius:1em}._3012a3{border-radius:1em;height:2px;transition:width .2s;background:linear-gradient(90deg, var(--primary), var(--green))}.ba6ce3{position:absolute;top:2px;left:2px;right:2px}", ""]);
// Exports
exports.locals = {
	"wrap": "_37af77",
	"filler": "_3012a3",
	"sticky": "ba6ce3"
};
module.exports = exports;
